<template lang="pug">
AuthorHistory(:key="fileName" v-bind="courseAndFirm" v-if="open")
</template>

<script setup lang="ts">
import AuthorHistory from './AuthorHistory.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const open = computed(() => {
  return useRoute().path.startsWith('/history');
});

const fileName = computed(() => useRoute().params.fileName as string);

const courseAndFirm = computed(() => {
  const [courseIdStr = '', firmCodeStr = ''] = fileName.value
    .split('_')
    .reverse();

  const courseId = Number(courseIdStr);
  const firmCode = firmCodeStr;

  return { courseId, firmCode };
});
</script>
